import { IComparable } from "../IComparable";

export interface IBigNumber extends IComparable {
    toString(): string;
    toLocaleString(locales?: string, options?: Intl.NumberFormatOptions): string;

    /** Vrátí true, pokud je hodnota BigNumber větší nebo rovna hodnotě `n`, v opačném případě vrátí false. */
    gte(n: number | string): boolean;
    /** Vrátí true, pokud je hodnota BigNumber menší nebo rovna hodnotě `n`, v opačném případě vrátí false. */
    lte(n: number | string): boolean;
    /** Vrací true, pokud je hodnota BigNumber NaN, jinak vrací false. */
    isNaN(): boolean;
}
